module.exports = __webpack_public_path__ + "img/notification.2a7a2370.svg";